import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

import { AuthService } from '../auth/services/auth.service';
import { HttpConfigInterceptor } from './interceptor/http-config.interceptor';

@NgModule({
    providers: [
        ConfirmationService,
        MessageService,
        AuthService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    ],
})
export class CoreModule {}
